<i18n src="../../locales/lang.json"></i18n>

<template>
  <div>
    <table style="width:100%">
      <tr>
        <td>
          <div class="row mt-3">
            <div class="col p-0" style="position:relative">
              <div class="" style="position:absolute;max-width:100%; overflow-x: scroll; display: block; overflow-x: scroll; margin-right: 180px;">
                <table style="border-collapse: initial;margin-bottom:5px;margin-left:-8px;margin-top:-8px;" cellspacing="8">
                  <tr>
                    <td class="mr-2 skin rounded dark-bg align-top p-2" style="min-width:250px;margin-right:5px;">
                      <div class="container-fluid">
                        <div class="row" id="divAddTeamOption">
                          <a href="#" @click="showHide(true)">+ {{ $store.translate('add_team') }}</a>
                        </div>
                        <div class="row" id="divAddTeam">
                          <div class="col-12">
                            <form id="createTeamFormSch" name="createTeamFormSch" class="login-formx form-validate" action="index.html" onsubmit="return false">
                              <div class="form-group row mt-1">
                                <div class="col-lg-12">
                                  <input required v-model="teamname" type="text" id="txtteamname" v-bind:placeholder="$t('team_name')" maxlength="200" name="teamname" class="form-control" />
                                </div>
                              </div>
                              <div class="form-group row mt-3">
                                <div class="col-lg-12">
                                  <button @click="saveteam" type="submit" class="btn skin primary-button pull-left"><i class="icon-cog5 mr-2"></i> {{$t('save')}}</button>
                                  <button type="button" class="btn btn-link pull-right" @click="showHide(false)">{{$t('cancel')}}</button>
                                </div>
                              </div>
                            </form>
                          </div>
                        </div>
                      </div>
                    </td>
                    <td v-for="(shift, index) in data" v-bind:class="index==selectedIndex?'skin rounded dark-bg':'skin rounded dark-bg'" class="mr-2" style="min-width:250px;margin-right:5px;">
                      <div class="container-fluid">
                        <div class="row">
                          <div class="col my-1">
                            <span class="custom-table-text card-title">
                              <!--<a @click="manageShifts(shift.DayId,index)" class="daylink" v-bind:href="'#accordion-child' + shift.DayId" v-bind:class="[(shift.DayId==1 && shift.LocationShifts.length > 0) || index==selectedIndex ? '' : 'collapsed']" v-bind:id="'accordion-control' + shift.DayId" data-toggle="collapse" aria-expanded="false" style="margin-left:20px;color:inherit !important;">-->
                              <a @click="manageShifts(shift.DayId,index,shift.Day)" class="daylink" v-bind:href="'#accordion-child' + shift.DayId" v-bind:id="'accordion-control' + shift.DayId" data-toggle="collapse" aria-expanded="false" style="color:inherit !important;">
                                {{ $t(shift.Day.toLowerCase()) }}
                              </a>
                            </span>
                            <div class="dropdown" style="position: absolute; top: 2px; right: 18px; color: #aeaaaa">
                              <a href="#" class="list-icons-item caret-0 font-weight-bold" data-toggle="dropdown">
                                <i class="icon-menu" style="margin-top:-15px;margin-right:-10px;color:inherit;"></i>
                              </a>
                              <div class="skinnedmenu dropdown-menu dropdown-menu-right viewportfix">
                                <a @click="openTeamInvite(shift)" href="javascript: return false;" class="dropdown-item">{{$t('share')}}</a>
                                <a @click="deleteTeam(shift)" href="javascript: return false;" class="dropdown-item">{{$t('delete')}}</a>
                              </div>
                            </div>
                          </div>


                        </div>
                        <div class="row">

                          <div class="p-0" style="height: calc(-250px + 100vh); overflow-y: scroll; width: 100%;">
                            <div v-bind:id="'divdrag' +  procSch.id+'_'+procSch.Order+'_'+shift.Day+'_'+shift.DayId" v-bind:draggable="{'true':allowSort == true}" ondragstart="drag(event)" ondragend="dragend(event)" ondrop="drop(event,'teamSchedulingControlNew')" ondragover="allowDrop(event)" v-for="procSch in shift.Procedures" class="row skin white p-2 m-1 shadow-1 rounded">
                              <div class="col-12 p-0">
                                <div class="col-12 smaller-text" @click.self="editProcedure(procSch)">
                                  {{ procSch.name }}
                                  <span v-if="procSch.WeekRepeat > 0"><i style="line-height:0.7rem;font-size:0.7rem;" class="ml-1 icon-rotate-cw3"></i></span>
                                  <span v-if="procSch.StartDateStr !='' && procSch.EndDateStr !=''"><i style="line-height:0.7rem;font-size:0.7rem;" class="ml-1 icon-calendar"></i></span>
                                  <span v-if="procSch.Weekdays != null && procSch.Weekdays.indexOf(',') > -1"><i style="line-height:0.7rem;font-size:0.7rem;" class="ml-1 icon-stack"></i></span>
                                  <div class="dropdown" style="position: absolute; top: -5px; right: 5px; color: #aeaaaa">
                                    <a href="#" class="list-icons-item caret-0 font-weight-bold" data-toggle="dropdown">
                                      <i class="icon-menu" style="margin-top:-15px;margin-right:-10px;color:inherit;"></i>
                                    </a>
                                    <div class="skinnedmenu dropdown-menu dropdown-menu-right viewportfix">
                                      <a @click="removeProcdure(procSch.id,shift.DayId)" href="javascript: return false;" class="dropdown-item">{{$t('remove')}}</a>
                                      <!--<a @click="edit(procSch.id)" href="javascript: return false;" class="dropdown-item">{{$t('edit')}}</a>-->
                                    </div>
                                  </div>
                                </div>
                              </div>

                            </div>
                          </div>
                        </div>


                        <div class="row my-1 px-3">
                          <div class="col-12 px-0">
                            <procedure-selector-with-add v-bind:format="true" v-bind:data="shift.DayId" ref="procedureselector" @event-add-procedure="attachProcdureShift(shift.DayId,...arguments)" @event-change-procedure="onChangeProcedure"></procedure-selector-with-add>
                          </div>
                        </div>
                      </div>
                    </td>


                  </tr>
                </table>
              </div>
            </div>
          </div>
        </td>
      </tr>

    </table>
    <team-registration-invite ref="teamRegsitrationInviteSelector"></team-registration-invite>
  </div>
</template>

<script>
  import TeamRegisterInvite from "../team/team-registration-invite.vue";
  var selectedIndex = -1;
  export default {
    name: "team-scheduling",
    components: {
      TeamRegisterInvite
    },
    props: {
      selectedIndex: {
        type: Number,
        default: -1,

      },
    },
    data() {
      return {
        newProcedureName: '',
        data: null,
        bgcolor: 'background-color: #F6F7F7 !important; color:black',
        activebgcolor: 'background-color: #03a9f4 !important; color:white',
        day: '',
        locShiftId: -1,
        items: [],
        procId: 0,
        dayid: 0,
        selectedProcedureSchedule: null,
        teamname: '',
      };
    },
    methods: {
      openTeamInvite(team) {
        this.$refs.teamRegsitrationInviteSelector.open(team.DayId);
      },
      deleteTeam(team) {
        var context = this;
        bootbox.confirm(this.$t('delete_group'), function (result) {
          if (result) {
            try {
              console.log('team-' + team);
              var url = '/api/Team/delete?id=' + team.DayId;
              context.$http.get(url).then(async response => {
                console.log(response.data);
                if (response.data === true) {
                  const index = context.data.indexOf(team);
                  if (index > -1) { // only splice array when item is found
                    context.data.splice(index, 1); // 2nd parameter means remove one item only
                  }
                } else {
                  alert(context.$t('entity_not_delete'));
                }
              });
            } catch (err) {
              alert(err);
            }
          }
        });
      },
      showHide(val) {
        if (val) {
          $('#divAddTeamOption').hide();
          $('#divAddTeam').show();
        } else {
          $('#divAddTeamOption').show();
          $('#divAddTeam').hide();
        }
      },
      async saveteam() {
        if (!$('#createTeamFormSch').valid())
          return false;
        if (this.teamname === '') {
          return false;
        }
        var request = { teamid: 0, name: this.teamname, email: '' };

        try {
          var response = await this.$http.post(
            '/api/Teams/v1',
            request
          ).then(async response => {
            this.teamname = '';
            //this.fetchReloadData();
            var team = response.data;
            if (team != null && this.data != null) {
              var tempDataArray = [];
              tempDataArray.push({ Day: team.Name, DayId: team.Id, Procedures: [] });
              for (let i = 0; i < this.data.length; i++) {
                tempDataArray.push(this.data[i]);
              }
              //this.data.push({ Day: team.Name, DayId: team.Id, Procedures: [] });
              this.data = [];
              this.data = tempDataArray;
            }
            this.showHide(false);
          })

        } catch (err) {

        }
      },
      onOrderChange(arraydragids, arraydropids) {
        //if (!this.dataIsSortedBySelf) {
        //  return;
        //}
        var dragId = arraydragids[0];
        var dragOrder = arraydragids[1];

        var dropId = arraydropids[0];
        var dropOrder = arraydropids[1];

        //console.log("dragId=" + dragId + "dropId=" + dropId);
        if (dragId !== '' && dropId !== '' && dragId !== undefined && dropId !== undefined
          && dragId !== dropId) {

          var procedures = [];
          // checking day for drag drop elements
          if (arraydragids[3] === arraydropids[3]) {
            var item = this.data.find(n => n.DayId == arraydropids[3]);
            if (item != null) {
              procedures = item.Procedures;
            }
          }

          if (procedures !== null && procedures !== undefined && procedures.length > 0) {
            for (let i = 0; i < procedures.length; ++i) {
              if (procedures[i].id == dragId) {

                if (procedures[i].Order == dropOrder) {
                  procedures[i].Order = dropOrder + 0.1;
                } else {
                  procedures[i].Order = dropOrder;
                }
              }
            }
            procedures = procedures.sort((a, b) => (a.Order > b.Order ? 1 : -1));

            for (let i = 0; i < procedures.length; ++i) {
              procedures[i].Order = i;
            }

            procedures = procedures.sort((a, b) => (a.Order > b.Order ? 1 : -1));

            this.$forceUpdate();
            try {
              var url = '/api/Procedure/UpdateMultipleActivitiesOrder';
              this.$http.post(url, procedures).then(async response => {
                //this.loadShiftProcedures(this.locationId, this.dayId, this.shiftId);
              });
            } catch (err) {
              alert(err);
            }
          }
        }
      },
      async removeProcdure(procId, dayid) {
        try {
          var url = '/api/Procedure/RemoveProcActivity?procSchId=' + procId;
          this.$http.get(url).then(async response => {
            this.getTeamSchActivityDetail(dayid);
          });
        } catch (err) {
          alert(err);
        }
      },
      async addProcedure(name, dayId) {
        var thisContext = this;
        var tmpProcedure = { name: name, istask: false };
        tmpProcedure.Settings = { Property: [] };
        tmpProcedure.Settings.Property["EnablePrivateChat"] = "True";
        var createProcedureData = JSON.stringify(tmpProcedure);

        var thisContext = this;
        var response = await this.$http.post(
          '/api/Procedure/AddProcedure',
          createProcedureData,
          {
            headers: {
              'Content-Type': 'application/json',
              "Accept": "application/json"
            }
          }
        )
          .then(response => {
            thisContext.$root.$emit('procedures_reload');
            thisContext.newProcedureName = '';
            thisContext.procId = response.data.Id;
            thisContext.dayid = dayId;
            thisContext.attachProcdureShift(dayId);
          });

      },
      async attachProcdureShift(dayId, name) {

        try {

          if (this.procId <= 0 && name != null) {
            //Add procedure and return the procedureId


            this.addProcedure(name, dayId);
            return false;
          }
          else if (this.procId === ''
            || this.procId < 0 || this.dayid !== dayId)
            return false;
          var request = { teamId: dayId, procId: this.procId };
          var response = await this.$http.post(
            '/api/Procedure/AddTeamProcActvity',
            request
          ).then(async response => {
            this.getTeamSchActivityDetail(this.dayid);
            this.procId = 0;
            this.dayid = 0;
          });
        } catch (err) {
          alert(err);
        }
      },
      fetchReloadData() {
        this.loadLocationShifts();
      },
      onChangeProcedure(id, dayid) {
        this.procId = id;
        this.dayid = dayid;
        this.attachProcdureShift(dayid);
      },
      onAddProcedure(text) {
        this.newProcedureName = text;
        //alert("add procedure:" + text);
      },

      async getTeamSchActivityDetail(teamid) {
        try {
          var url = `/api/Admin/v1/Teams/SchActivity/${teamid}`;
          this.$http.get(url).then(async response => {
            var procs = response.data;
            var item = this.data.find(n => n.DayId == teamid);
            console.log(item);
            if (item != null) {
              item.Procedures = [];
              item.Procedures = procs;
              console.log(item);
            }
            this.$forceUpdate();
          }, function (error) {
            this.data = null;
          });
        }
        catch (err) {
          //alert('some error:' + err)
        }
      },
      async loadLocationShifts() {
        this.data = [];
        try {
          var url = '/api/Admin/v1/Teams/SchActivity';
          this.$http.get(url).then(async response => {
            this.data = response.data;
            this.$forceUpdate();
          }, function (error) {
            this.data = null;
          });
        }
        catch (err) {
          //alert('some error:' + err)
        }
      },
      getId() {
        return this._uid;
      },
      editProcedure(procSchedule) {
        this.selectedProcedureSchedule = procSchedule;
        this.$root.$emit("editprocedure", procSchedule.procedureId)
      },
      procedureUpdated(val) {
        var storeProcedure = this.$store.getProcedure();
        if (this.selectedProcedureSchedule != null && storeProcedure.ProcedureId == this.selectedProcedureSchedule.procedureId) {
          this.selectedProcedureSchedule.name = storeProcedure.ProcedureName
        }
        //else
        //  alert("updated another procedure");
      }
    },
    watch: {
    },
    mounted() {
      this.placeholder = this.$store.translate('select_template');
      //this.$refs.locationselector.displayAddButton = false;
      this.$root.$on('procedure_editor_can_close', this.procedureUpdated);
      this.$root.$on('procedure_changed', this.procedureUpdated);
      this.$root.$on('procedure_loaded', this.procedureUpdated);
      _componentValidation('#createTeamFormSch');
      $('#divAddTeam').hide();
      //this.$root.$on('procedure_reset', this.procedureUpdated);

    }
  };
</script>

<style scoped>

  .card-group-control .card-title > a.collapsed::before {
    content: "\e9ca" !important;
  }

  .card-group-control .card-title > a.collapsed:before {
    content: "";
  }

  .card-group-control .card-title > a::before {
    content: "\e9c9" !important;
  }

  .daylink::before {
    left: 0px !important;
  }


  .alternating tr {
    border-top: 1px solid #ccc;
  }

    .alternating tr:first-child {
      border-top: 1px solid white;
    }

  .select_container {
    width: calc(100%)
  }

  .custom-table-text {
    font-size: 14px;
    height: 40px;
  }

  .smaller-text {
    font-size: 12px;
  }

  @media screen and (max-width:768px) {
    .custom-table-text {
      font-size: 10px;
    }
  }

  .select_container {
    width: 100%;
  }

  .select2-results__option[aria-selected="true"] {
    background-color: white !important;
  }

</style>




// WEBPACK FOOTER //
// src/components/shift/team-scheduling.vue